var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0378 1.96231C13.836 1.76132 13.5963 1.60231 13.3327 1.49447C13.069 1.38663 12.7866 1.33211 12.5017 1.33403C12.2169 1.33596 11.9352 1.39431 11.6731 1.50571C11.4109 1.6171 11.1734 1.77934 10.9743 1.98305L2.38209 10.5752L1.33325 14.6669L5.42491 13.6175L14.0171 5.02528C14.2209 4.82626 14.3832 4.58882 14.4946 4.32669C14.606 4.06456 14.6644 3.78295 14.6663 3.49812C14.6683 3.2133 14.6137 2.93092 14.5058 2.6673C14.398 2.40369 14.2389 2.16407 14.0378 1.96231V1.96231Z",
    stroke: "#7E898F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7295 2.22852L13.7717 5.27075",
    stroke: "#7E898F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38281 10.5742L5.428 13.6141",
    stroke: "#7E898F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEdit);
export default __webpack_public_path__ + "static/media/PenEdit.7d6adb575ca9aea794f0fcfa729eff56.svg";
export { ForwardRef as ReactComponent };